import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import nodata from "../../Img/newnodta.gif";
import {
  useTheme,
  useMediaQuery,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { useState, useEffect, useContext, useRef } from "react";
import usercalls from "../../Axios";
import { useLocation, useParams } from "react-router-dom";
import consts from "../../constant";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Context from "../../Context";
import { Capitalize } from "../../Helpers/StringFunctions";
import { getTimeFormat } from '../../Helpers/DateAndTime'

export default function Orderhistory() {
  const theme = useTheme();
  const mobilemd = useMediaQuery(theme.breakpoints.up("md"));

  const scrollRef = useRef(null);

  const {
    // getHistory,
    setOrderHistory,
    orderHistory,
    history,
    activeTabId,
  } = useContext(Context);
  const [historyDropdown, setHistoryDropDown] = useState("spot");

  const path = usercalls();

  const loaction = useLocation();
  const placeRoute = loaction.pathname?.split("/")[1];

  const { id } = useParams();

  const getHistory = async () => {
    try {
      setOrderHistory([]);
      const url =
        placeRoute === "trade"
          ? `${consts.BackendUrl}/ownTrade/orderhistory?page=1&limit=5`
          : `${consts.BackendUrl}/ownTrade/futureTradeHistory?page=1&limit=5`;
      const payload = {
        pair: id,
        type: placeRoute === "trade" ? historyDropdown : "futures",
        startDate: new Date(
          new Date().getTime() - 24 * 60 * 60 * 1000
        ).toISOString(),
        endDate: new Date().toISOString(),
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setOrderHistory(result?.result?.docs);
      }
    } catch (error) {
      console.log("🚀 ~ getHistory ~ error:", error);
    }
  };

  const handleHistoryDropdownChange = (e) => {
    setHistoryDropDown(e.target.value);
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const tableData1 = [
    {
      spotPairs: "BTC/USD",
      orderType: "Limit",
      direction: "Buy",
      orderValue: "1000 USD",
      orderQty: "0.5 BTC",
      orderPrice: "$20000",
      triggerPrice: "$19900",
      orderStatus: "Filled",
      triggerTime: "2025-01-20 10:00:00",
      orderTime: "2025-01-20 09:45:00",
      orderId: "ORD12345",
      action: "View",
    },
    {
      spotPairs: "ETH/USD",
      orderType: "Market",
      direction: "Sell",
      orderValue: "500 USD",
      orderQty: "2 ETH",
      orderPrice: "$2500",
      triggerPrice: "N/A",
      orderStatus: "Pending",
      triggerTime: "N/A",
      orderTime: "2025-01-19 14:30:00",
      orderId: "ORD12346",
      action: "Cancel",
    },
    {
      spotPairs: "XRP/USD",
      orderType: "Stop",
      direction: "Buy",
      orderValue: "300 USD",
      orderQty: "1500 XRP",
      orderPrice: "$2",
      triggerPrice: "$1.9",
      orderStatus: "Pending",
      triggerTime: "2025-01-20 12:00:00",
      orderTime: "2025-01-20 11:00:00",
      orderId: "ORD12347",
      action: "Modify",
    },
  ];

  function capitalizeFirstLetter(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const tableData2 = [
    {
      spotPairs: "BTC/USD",
      orderType: "Limit",
      direction: "Buy",
      orderValue: "1000 USD",
      orderQty: "0.5 BTC",
      orderPrice: "$20000",
      triggerPrice: "$19900",
      orderStatus: "Filled",
      triggerTime: "2025-01-20 10:00:00",
      orderTime: "2025-01-20 09:45:00",
      orderId: "ORD12345",
      action: "View",
    },
    {
      spotPairs: "ETH/USD",
      orderType: "Market",
      direction: "Sell",
      orderValue: "500 USD",
      orderQty: "2 ETH",
      orderPrice: "$2500",
      triggerPrice: "N/A",
      orderStatus: "Pending",
      triggerTime: "N/A",
      orderTime: "2025-01-19 14:30:00",
      orderId: "ORD12346",
      action: "Cancel",
    },
    {
      spotPairs: "XRP/USD",
      orderType: "Stop",
      direction: "Buy",
      orderValue: "300 USD",
      orderQty: "1500 XRP",
      orderPrice: "$2",
      triggerPrice: "$1.9",
      orderStatus: "Pending",
      triggerTime: "2025-01-20 12:00:00",
      orderTime: "2025-01-20 11:00:00",
      orderId: "ORD12347",
      action: "Modify",
    },
  ];

  const tableData3 = [
    {
      spotPairs: "BTC/USD",
      orderType: "Limit",
      direction: "Buy",
      orderValue: "1000 USD",
      orderQty: "0.5 BTC",
      tpSlOrderPrice: "$20000",
      tpSlTriggerPrice: "$19900",
      orderStatus: "Filled",
      triggerPrice: "$19900",
      triggerTime: "2025-01-20 10:00:00",
      orderTime: "2025-01-20 09:45:00",
      orderId: "ORD12345",
      action: "View",
    },
    {
      spotPairs: "ETH/USD",
      orderType: "Market",
      direction: "Sell",
      orderValue: "500 USD",
      orderQty: "2 ETH",
      tpSlOrderPrice: "$2500",
      tpSlTriggerPrice: "N/A",
      orderStatus: "Pending",
      triggerPrice: "N/A",
      triggerTime: "N/A",
      orderTime: "2025-01-19 14:30:00",
      orderId: "ORD12346",
      action: "Cancel",
    },
    {
      spotPairs: "XRP/USD",
      orderType: "Stop",
      direction: "Buy",
      orderValue: "300 USD",
      orderQty: "1500 XRP",
      tpSlOrderPrice: "$2",
      tpSlTriggerPrice: "$1.9",
      orderStatus: "Pending",
      triggerPrice: "$1.9",
      triggerTime: "2025-01-20 12:00:00",
      orderTime: "2025-01-20 11:00:00",
      orderId: "ORD12347",
      action: "Modify",
    },
  ];

  const [current_activeTab, setcurrent_ActiveTab] =
    useState("order-limit-market");
  const [current_activeTab1, setcurrent_ActiveTab1] = useState("Last 7 D");

  // const [orderHistory, setOrderHistory] = useState([])

  // const getHistory = async () => {
  //   try {
  //     setOrderHistory([])
  //     const url = `${consts.BackendUrl}/ownTrade/orderhistory?page=1&limit=5`
  //     const payload = {
  //       pair: id,
  //       type: placeRoute == "trade" ? "spot" : 'future',
  //     }
  //     const response = await path.postCall({ url, payload });
  //     const result = await response.json();
  //     if (result?.success) {
  //       setOrderHistory(result?.result?.docs);
  //     }
  //   } catch (error) {
  //     console.log("🚀 ~ getHistory ~ error:", error)
  //   }
  // }

  useEffect(() => {
    if ((id && activeTabId === "tab4") || placeRoute === "future") {
      getHistory();
    }
  }, [id, historyDropdown, activeTabId, history]);

  // useEffect(() => {
  //   if (id) {
  //     getHistory(placeRoute)
  //   }
  // }, [id, historyDropdown, placeRoute])

  return (
    <>
      <div className="history_inner_tab">
        <div className="h_tabs display-2">
          <button
            className={`history_button ${current_activeTab === "order-limit-market" ? "active" : ""
              }`}
            onClick={() => setcurrent_ActiveTab("order-limit-market")}
          >
            Limit & Market Orders
          </button>
          {placeRoute === "trade" && (
            <FormControl
              className="spot-drop-down"
              sx={{
                minWidth: "80px",
              }}
            >
              <Select
                label="Order Type"
                value={historyDropdown}
                onChange={handleHistoryDropdownChange}
                sx={{
                  "& .MuiInputBase-formControl": {
                    border: "0px",
                  },
                  "& fieldset": {
                    border: "none !important",
                  },
                  svg: {
                    fill: "#fff !important",
                    right: "0px !important",
                  },
                }}
              >
                <MenuItem value="spot">Spot</MenuItem>
                <MenuItem value="margin">Margin</MenuItem>
              </Select>
            </FormControl>
          )}
          {/* <button
            className={`history_button ${current_activeTab === "order TP/SL Order" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab("order TP/SL Order")}
          >
            TP/SL Order
          </button>
          <button
            className={`history_button ${current_activeTab === "order Conditional Order" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab("order Conditional Order")}
          >
            Conditional Order
          </button>
          <button
            className={`history_button bddr ${current_activeTab === "order OCO" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab("order OCO")}
          >
            OCO
          </button>
          <button
            style={{ background: "transparent" }}
            className={`history_button ${current_activeTab1 === "Last 7 D" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab1("Last 7 D")}
          >
            Last 7 D
          </button>
          <button
            style={{ background: "transparent" }}
            className={`history_button ${current_activeTab1 === "Last 30 D" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab1("Last 30 D")}
          >
            Last 30 D
          </button>
          <button
            style={{ background: "transparent" }}
            className={`history_button ${current_activeTab1 === "Last 180 D" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab1("Last 180 D")}
          >
            Last 180 D
          </button> */}
          <ChevronRightIcon
            sx={{ display: !mobilemd ? "block" : "none" }}
            className="scroll-btn"
            onClick={scrollRight}
          />
        </div>
        {current_activeTab === "order-limit-market" && (
          <div className="table_height">
            <TableContainer className="history_table">
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Order Time</TableCell>
                    <TableCell align="center">Pairs</TableCell>
                    <TableCell align="center">Order Type</TableCell>
                    <TableCell align="center">Side</TableCell>
                    {/* <TableCell align="left">Order Value</TableCell> */}
                    <TableCell align="center">Order Price</TableCell>
                    <TableCell align="center">Amount</TableCell>
                    {/* {
                      placeRoute === "future" &&
                      <TableCell align="left">Reduce Only</TableCell>
                    } */}
                    {/* <TableCell align="left">TP/SL</TableCell> */}
                    {/* <TableCell align="left">Order ID</TableCell> */}
                    {/* <TableCell align="center">Trading Fee</TableCell> */}
                    <TableCell align="center">Status</TableCell>
                    {/* <TableCell align="left" className="fixed-right">Action</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderHistory?.length > 0 ? (
                    orderHistory?.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="left">
                          {getTimeFormat(row?.createdAt)}
                          {/* {row?.createdAt?.split("T")[0]}:{" "}
                          {row?.createdAt?.split("T")[1].split(".")[0]} */}
                        </TableCell>
                        <TableCell align="center">{row?.pair}</TableCell>
                        <TableCell align="center">{capitalizeFirstLetter(row?.order_type)}</TableCell>
                        {placeRoute == "future" ? (
                          // <TableCell>{row?.positionSide == "LONG" && row?.trade_type == "BUY" ? "Open Long" : row?.positionSide == "SHORT" && row?.trade_type == "BUY" ? "Close Long" : row?.positionSide == "LONG" && row?.trade_type == "SELL" ? "Close Short" : "Open Short"}</TableCell>
                          <>
                            {row?.positionSide == "long" &&
                              row?.trade_type == "sell" && (
                                <TableCell align="center">Close Long</TableCell>
                              )}

                            {row?.positionSide == "short" &&
                              row?.trade_type == "buy" && ( // correct
                                <TableCell align="center">
                                  Close Short
                                </TableCell>
                              )}

                            {row?.positionSide == "long" &&
                              row?.trade_type == "buy" && (
                                <TableCell align="center">Open Long</TableCell>
                              )}

                            {row?.positionSide == "short" &&
                              row?.trade_type == "sell" && (
                                <TableCell align="center">Open Short</TableCell>
                              )}
                          </>
                        ) : (
                          <TableCell align="center">
                            {capitalizeFirstLetter(row?.trade_type)}
                          </TableCell>
                        )}
                        {/* <TableCell align="left">{row.orderValue}</TableCell> */}
                        <TableCell align="center">
                          {row?.price == 0 ? "-" : row?.price}
                          {" "}
                          {
                            (placeRoute == "trade" || placeRoute == "future") && row?.price ?
                              // row?.order_type == "limit" ?
                              row?.pair?.split('_')[1]
                              :
                              ""
                          }
                        </TableCell>
                        <TableCell align="center">
                          {row?.volume}
                          {" "}
                          {
                            (placeRoute == "trade") ?
                              row?.order_type == "limit" ?
                                row?.pair?.split('_')[0] :
                                row?.order_type == "market" && row?.trade_type == "buy" ?
                                  row?.pair?.split('_')[1] :
                                  row?.order_type == "market" && row?.trade_type == "sell" ?
                                    row?.pair?.split('_')[0] :
                                    ""
                              :
                              ""
                          }

                          {
                            placeRoute == "future" &&
                              row?.order_type == "limit" ?
                              row?.pair?.split('_')[0] :
                              row?.order_type == "market" && row?.trade_type == "buy" && row?.positionSide == "long" ?
                                row?.pair?.split('_')[1] :
                                row?.order_type == "market" && row?.trade_type == "sell" && row?.positionSide == "long" ?
                                  row?.pair?.split('_')[0] :
                                  row?.order_type == "market" && row?.trade_type == "buy" && row?.positionSide == "short" ?
                                    row?.pair?.split('_')[0] :
                                    row?.order_type == "market" && row?.trade_type == "sell" && row?.positionSide == "short" ?
                                      row?.pair?.split('_')[1] :
                                      ""
                          }
                        </TableCell>
                        {/* {
                          placeRoute === "future" &&
                          <>
                            {(row?.positionSide === "LONG" && row?.trade_type === "SELL") || (row?.positionSide === "SHORT" && row?.trade_type === "BUY") ?
                              <TableCell align="left">Yes</TableCell>
                              :
                              <TableCell align="left">No</TableCell>
                            }
                          </>
                        } */}
                        {/* <TableCell align="left">{row.tpSl}</TableCell> */}
                        {/* <TableCell align="left">{row?.order_id}</TableCell> */}
                        {/* <TableCell align="center">
                          {" "}
                          {row?.fees}{" "}
                          {placeRoute === "trade" ? row.fee_taken_Asset : ""}
                        </TableCell> */}
                        <TableCell
                          align="center"
                          style={
                            row?.status?.toUpperCase() === "FILLED"
                              ? { color: "green " }
                              : {}
                          }
                        >
                          {" "}
                          {row?.status ? row?.status?.toUpperCase() : "Filled"}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <img
                          src={nodata}
                          alt="No Data"
                          style={{ maxWidth: "100px" }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        {current_activeTab === "order TP/SL Order" && (
          <div className="table_height">
            <TableContainer className="history_table">
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell align="left" className="fixed-left">
                      Spot Pairs
                    </TableCell>
                    <TableCell align="left">Order Type</TableCell>
                    <TableCell align="left">Direction</TableCell>
                    <TableCell align="left">Order Value</TableCell>
                    <TableCell align="left">Order Qty</TableCell>
                    <TableCell align="left">Order Price</TableCell>
                    <TableCell align="left">Trigger Price</TableCell>
                    <TableCell align="left">Order Status</TableCell>
                    <TableCell align="left">Order Time</TableCell>
                    <TableCell align="left">Order ID</TableCell>
                    <TableCell align="left" className="fixed-right">
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData1 && tableData1.length > 0 ? (
                    tableData1.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="left" className="fixed-left">
                          {row.spotPairs}
                        </TableCell>
                        <TableCell align="left">{row.orderType}</TableCell>
                        <TableCell align="left">{row.direction}</TableCell>
                        <TableCell align="left">{row.orderValue}</TableCell>
                        <TableCell align="left">{row.orderQty}</TableCell>
                        <TableCell align="left">{row.orderPrice}</TableCell>
                        <TableCell align="left">{row.triggerPrice}</TableCell>
                        <TableCell align="left">{row.orderStatus}</TableCell>
                        <TableCell align="left">{row.orderTime}</TableCell>
                        <TableCell align="left">{row.orderId}</TableCell>
                        <TableCell align="left" className="fixed-right">
                          {row.action}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <img
                          src={nodata}
                          alt="No Data"
                          style={{ maxWidth: "100px" }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        {current_activeTab === "order Conditional Order" && (
          <div className="table_height">
            <TableContainer className="history_table">
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell align="left" className="fixed-left">
                      Spot Pairs
                    </TableCell>
                    <TableCell align="left">Order Type</TableCell>
                    <TableCell align="left">Direction</TableCell>
                    <TableCell align="left">Order Value</TableCell>
                    <TableCell align="left">Order Qty</TableCell>
                    <TableCell align="left">Order Price</TableCell>
                    <TableCell align="left">Trigger Price</TableCell>
                    <TableCell align="left">Order Status</TableCell>
                    <TableCell align="left">Order Time</TableCell>
                    <TableCell align="left">Order ID</TableCell>
                    <TableCell align="left" className="fixed-right">
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData2 && tableData2.length > 0 ? (
                    tableData2.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="left" className="fixed-left">
                          {row.spotPairs}
                        </TableCell>
                        <TableCell align="left">{row.orderType}</TableCell>
                        <TableCell align="left">{row.direction}</TableCell>
                        <TableCell align="left">{row.orderValue}</TableCell>
                        <TableCell align="left">{row.orderQty}</TableCell>
                        <TableCell align="left">{row.orderPrice}</TableCell>
                        <TableCell align="left">{row.triggerPrice}</TableCell>
                        <TableCell align="left">{row.orderStatus}</TableCell>
                        <TableCell align="left">{row.orderTime}</TableCell>
                        <TableCell align="left">{row.orderId}</TableCell>
                        <TableCell align="left" className="fixed-right">
                          {row.action}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <img
                          src={nodata}
                          alt="No Data"
                          style={{ maxWidth: "100px" }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        {current_activeTab === "order OCO" && (
          <div className="table_height">
            <TableContainer className="history_table">
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell align="left" className="fixed-left">
                      Spot Pairs
                    </TableCell>
                    <TableCell align="left">Order Type</TableCell>
                    <TableCell align="left">Direction</TableCell>
                    <TableCell align="left">Order Value</TableCell>
                    <TableCell align="left">Order Qty</TableCell>
                    <TableCell align="left">TP/SL Order Price</TableCell>
                    <TableCell align="left">TP/SL Trigger Price</TableCell>
                    <TableCell align="left">Order Status</TableCell>
                    <TableCell align="left">Trigger Price</TableCell>
                    <TableCell align="left">Trigger Time</TableCell>
                    <TableCell align="left">Order Time</TableCell>
                    <TableCell align="left">Order ID</TableCell>
                    <TableCell align="left" className="fixed-right">
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData3 && tableData3.length > 0 ? (
                    tableData3.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="left" className="fixed-left">
                          {row.spotPairs}
                        </TableCell>
                        <TableCell align="left">{row.orderType}</TableCell>
                        <TableCell align="left">{row.direction}</TableCell>
                        <TableCell align="left">{row.orderValue}</TableCell>
                        <TableCell align="left">{row.orderQty}</TableCell>
                        <TableCell align="left">{row.tpSlOrderPrice}</TableCell>
                        <TableCell align="left">
                          {row.tpSlTriggerPrice}
                        </TableCell>
                        <TableCell align="left">{row.orderStatus}</TableCell>
                        <TableCell align="left">{row.triggerPrice}</TableCell>
                        <TableCell align="left">{row.triggerTime}</TableCell>
                        <TableCell align="left">{row.orderTime}</TableCell>
                        <TableCell align="left">{row.orderId}</TableCell>
                        <TableCell align="left" className="fixed-right">
                          {row.action}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={13} align="center">
                        <img
                          src="nodata.png"
                          alt="No Data"
                          style={{ maxWidth: "100px" }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </div>
    </>
  );
}
